// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'draf... Remove this comment to see the full error message
import EmailAddressPattern from 'PatternValidationJS/patterns/EmailAddress';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'draf... Remove this comment to see the full error message
import DomainPattern from 'PatternValidationJS/patterns/Domain';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'draf... Remove this comment to see the full error message
import UrlPattern from 'PatternValidationJS/patterns/Url';
import { propertyKeyValidationTypes } from '../constants/properties';
import { phone_regex_country_code, phone_regex_no_country_code } from '../constants/regExp';
const editPropertyValidators = (fieldName, value) => {
  switch (fieldName) {
    case propertyKeyValidationTypes.email:
      return EmailAddressPattern.test(value);
    case propertyKeyValidationTypes.domain:
      return DomainPattern.test(value);
    case propertyKeyValidationTypes.linkedin_company_page:
      return UrlPattern.test(value);
    case propertyKeyValidationTypes.phone:
      return phone_regex_country_code.test(value) || phone_regex_no_country_code.test(value);
    default:
      return true;
  }
};
export default editPropertyValidators;